export const DEFAULT_LAT_LONG = { lat: 42.331429, lng: -83.045753 }
